import { FetcherOptions } from '../../../components/Hooks/useList.types';
import { fetcher } from '../../../components/Hooks/useListActions';
import { paginate } from '../../../lib/nest';
import { PaginatedResponse } from '../../../types/request.types';

export const createFetcherOfflineImplementation =
  <T extends unknown>(
    offlineFetcher: (
      params: { limit: number; skip: number } & { params?: FetcherOptions['params'] },
    ) => Promise<PaginatedResponse<T>>,
  ): ReturnType<typeof fetcher<T>> =>
  async ({ count, page, params }: FetcherOptions) => {
    const { limit } = paginate.limit(count);
    const { skip } = paginate.skip(page * count);

    try {
      const data = await offlineFetcher({ limit, skip, params });

      return {
        ...data,
        tag: 'success',
      };
    } catch (_) {
      return { tag: 'error', error: 'erro ao carregar a lista' };
    }
  };
